import { type EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { ControllerBinding } from '@wix/wix-data-client-common'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import { getComponentTypeData } from '../../business-logic/components/getComponentTypeData'
import { parseBindings } from './parseBindings'

export const fetchControllerBindings = async ({
  editorSdkProxy,
  controllerRef,
}: {
  editorSdkProxy: EditorSDK
  controllerRef: ComponentRef
}): Promise<ControllerBinding[]> => {
  const connections =
    await editorSdkProxy.controllers.listControllerConnections({
      controllerRef,
    })

  return Promise.all(
    connections.map(async ({ componentRef, connection }) => {
      const { role, config } = connection

      const { sdkType } = await getComponentTypeData({
        editorSdkProxy,
        componentRef,
      })

      const bindings = parseBindings(config)

      return {
        componentRef,
        role,
        componentType: sdkType,
        bindings,
      }
    }),
  )
}
